import React from 'react';

export const DateInput = ({value, onClick, style, disabled}) => (
  <button className={'date-input' + (disabled ? '-disabled' : '')} onClick={onClick} style={style}>
    {value}
  </button>
);
